<template>
  <div class="relative bg-white overflow-visible w-screen">
    <slot />
  </div>
</template>

<script setup lang="ts">
// @ts-ignore - Nuxt 2 head() not available in script setup, using useHead when available
</script>
